import { useAppSelector } from "@assessment/store/store";
import Tabs from "@lxp-app/components/atoms/tabs";
import orgBasedFeatureNameMapping from "@assessment/utils/orgBasedFeatureName";
import { useTranslation } from "react-i18next";

import { removeInlineColors } from "@assessment/utils/global/removeInlineColor";
import convertToTitleCase from "@assessment/utils/convertToTitleCase";

interface InstructionsTitleMap {
  schedule: string;
  qp: string;
}

const Instructions = ({ instructionType }: { instructionType: any }) => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.UserInfoSlice.profile);

  let orgBasedFeatureName =
    orgBasedFeatureNameMapping[(user?.org as string) || "default"] ||
    orgBasedFeatureNameMapping["default"];
  orgBasedFeatureName = convertToTitleCase(orgBasedFeatureName);

  const instructionsTitleMap: InstructionsTitleMap = {
    schedule: t("assessment.labels.guidelines"),
    qp: t("assessment.labels.showFeatureInstructions", {
      featureName: orgBasedFeatureName
    })
  };

  const tabs = instructionType?.map((instruction: "schedule" | "qp") => ({
    label: instructionsTitleMap[instruction]
  }));

  const scheduleInstruction = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData?.scheduleInstruction
  );

  const questionInstruction = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData?.qpInstruction
  );
  const updatedScheduleInstruction = removeInlineColors(scheduleInstruction);

  const updatedQuestionInstruction = removeInlineColors(questionInstruction);

  const renderChildrenArr = () => {
    if (instructionType.length === 2) {
      return [
        <ScheduleInstructions instruction={updatedScheduleInstruction} />,
        <QuestionInstructions instruction={updatedQuestionInstruction} />
      ];
    }
    if (
      instructionType.includes("schedule") &&
      !instructionType.includes("qp")
    ) {
      return [
        <ScheduleInstructions instruction={updatedScheduleInstruction} />
      ];
    }
    if (
      !instructionType.includes("schedule") &&
      instructionType.includes("qp")
    ) {
      return [
        <QuestionInstructions instruction={updatedQuestionInstruction} />
      ];
    }
    return [];
  };

  return (
    <div className="mt-5 h-fit">
      {tabs?.length > 0 && (
        <Tabs tabs={tabs} children={renderChildrenArr()}></Tabs>
      )}
    </div>
  );
};

export default Instructions;

export const ScheduleInstructions = ({ instruction }: { instruction: any }) => {
  return (
    <div
      // style={{ width: "80vw" }}
      className="min-w-full p-6 min-h-[50vh] max-h-[70vh]  thin-scrollbar overflow-y-auto"
    >
      <div className="remove-tailwind text-left">
        <div className="w-full max-w-full overflow-hidden">
          <div
            style={{
              width: "fit-content",
              height: "fit-content"
            }}
            className="min-w-full min-h-full"
          >
            <div className="remove-tailwind text-left">
              <div className="w-full max-w-full overflow-hidden">
                <div
                  className={`text-left rich-text-container`}
                  dangerouslySetInnerHTML={{
                    __html: instruction
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const QuestionInstructions = ({ instruction }: { instruction: any }) => {
  return (
    <div
      // style={{ width: "80vw" }}
      className="min-w-full p-6 min-h-[50vh] max-h-[70vh] thin-scrollbar overflow-y-auto"
    >
      <div className="remove-tailwind text-left">
        <div className="w-full max-w-full overflow-hidden">
          <div
            style={{
              width: "fit-content",
              height: "fit-content"
            }}
            className="min-w-full min-h-full"
          >
            <div className="remove-tailwind text-left">
              <div className="w-full max-w-full overflow-hidden">
                <div
                  className={`text-left rich-text-container`}
                  dangerouslySetInnerHTML={{
                    __html: instruction
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
